export default[
    {
        path: '/universign/transaction',
        name: 'universign-transaction',
        component: () => import('@/views/universign/Transaction.vue'),
    },
    {
        path: '/universign/mandat/:id/:compte',
        name: 'universign-mandat',
        component: () => import('@/views/SignatureMandat.vue'),
        meta: {
            layout: 'full',
            resource: 'Auth',
            //redirectIfLoggedIn: true,
        },
    },
    {
        path: '/mandatsepa',
        name: 'mandat-sepa',
        component: () => import('@/views/MandatSepaComponenet.vue'),
    }
]
